export const createIndexedDBStorage = () => {
    const dbName = 'axios-cache';
    const storeName = 'cache';


    const openDatabase = () => {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(dbName, 1);
            request.onupgradeneeded = (event) => {
                const db = event.target.result;
                if (!db.objectStoreNames.contains(storeName)) {
                    db.createObjectStore(storeName);
                }
            };

            request.onsuccess = (event) => resolve(event.target.result);
            request.onerror = (event) => reject(event.target.error);
        });
    };

    const withStore = async (mode, callback) => {
        const db = await openDatabase();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(storeName, mode);
            const store = transaction.objectStore(storeName);
            const request = callback(store);
            request.onsuccess = (event) => resolve(event.target.result);
            request.onerror = (event) => reject(event.target.error);
        });
    };




    return {
        async find(key) {
            return withStore('readonly', (store) => store.get(key));
        },
        async set(key, value) {
            await withStore('readwrite', (store) => store.put(value, key));
        },
        async remove(key) {
            await withStore('readwrite', (store) => store.delete(key));
        },
        async clear() {
            await withStore('readwrite', (store) => store.clear());
        },
    };
};